import { useEffect, useState } from 'react'
import { getClassNameForField, newsFields as fields } from '../../constants'
import { EditableFormPage } from '../components/EditableFormPage'
import NewsSlug from '../../public/pages/NewsSlug'
import { useParams } from 'react-router-dom'
import { Button } from '../../shared/components/Button'
import { FaEye, FaTrash } from 'react-icons/fa'
import { FaEyeSlash } from 'react-icons/fa6'
import { useDeleteItem } from '../../util/deleteItem'
import ConfirmDeleteModal from '../components/DeleteModal'
import { useTranslation } from 'react-i18next'
import { useTranslationService } from '../../util/TranslationContext'
import { fetchWithLanguage } from '../../util/fetchFunction'
import { languageUtil } from '../../util/languageUtils'

const NewsSlugAdmin = () => {
    const [preview, setPreview] = useState(false)
    const [showConfirm, setShowConfirm] = useState(false)
    const { id } = useParams()
    const { t } = useTranslation()

    const [news, setNews] = useState(null)
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState(null)

    const { translateFields } = useTranslationService()
    const newsFields = translateFields(fields, 'news')
    const { language } = languageUtil()

    const deleteItem = useDeleteItem()
    const handleDelete = async () => {
        await deleteItem({
            url: `admin/news/${id}`,
            navigateSuccess: '/admin/auth/news',
            onError: msg => alert(msg),
        })
    }

    useEffect(() => {
        const fetchNews = async () => {
            await fetchWithLanguage(`get-news-detail/${id}`, setNews, setError, setLoading)
        }

        fetchNews()
    }, [id, language])

    return (
        <>
            <div
                className={`flex items-center ${
                    news?.is_active === 1 || news?.is_active === '1'
                        ? 'justify-between'
                        : 'justify-end'
                } `}
            >
                {(news?.is_active === 1 || news?.is_active === '1') && (
                    <Button variant='primary' className='mb-4' onClick={() => setPreview(!preview)}>
                        {!preview ? <FaEye /> : <FaEyeSlash />} {t('status.preview')}
                    </Button>
                )}
                <Button variant='danger' className='mb-4' onClick={() => setShowConfirm(true)}>
                    <FaTrash /> {t('status.delete')}
                </Button>

                <ConfirmDeleteModal
                    isOpen={showConfirm}
                    onClose={() => setShowConfirm(false)}
                    onConfirm={handleDelete}
                />
            </div>
            {preview ? (
                <NewsSlug />
            ) : (
                <>
                    <EditableFormPage
                        fetchUrl={`admin/news/${id}?_method=PUT`}
                        fields={newsFields}
                        classNameForField={getClassNameForField}
                    />
                </>
            )}
        </>
    )
}

export default NewsSlugAdmin
